import { useEffect, useMemo, useState } from 'react';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import { ListerProductData } from '../../../../../types';

export interface RowProps {
  hasColorSwatches: boolean;
  hasIfcMessage: boolean;
}

export interface RowPropsMap {
  row: number;
  rowProps: RowProps[];
}

function useRowProps(products: ListerProductData[], isBiggerImages: boolean): RowPropsMap[] {
  const [columns, setColumns] = useState(1);
  const [rowPropsMap, setMap] = useState<RowPropsMap[]>([]);
  const { isSmall, isMedium, isLarge, isXLargeUp } = useMediaQuery();
  const hardCodedColumnsCount = useMemo(() => {
    if (isBiggerImages) {
      if (isSmall) return 1;
      if (isMedium) return 2;
      if (isLarge) return 2;
      if (isXLargeUp) return 3;
    }
    if (isSmall) return 2;
    if (isMedium) return 2;
    if (isLarge) return 3;
    if (isXLargeUp) return 4;
    return 1;
  }, [isBiggerImages, isSmall, isMedium, isLarge, isXLargeUp]);

  useEffect(() => {
    setColumns(hardCodedColumnsCount);
  }, [hardCodedColumnsCount]);

  useEffect(() => {
    const rowProps: RowProps[] = [];
    const map: RowPropsMap[] = [];

    products.forEach((p, i) => {
      const row = Math.floor(i / columns);
      rowProps[row] = {
        hasColorSwatches: rowProps[row]?.hasColorSwatches || !!p.availableColorSwatches,
        hasIfcMessage: rowProps[row]?.hasIfcMessage || !!p.financingPromoMessage
      };

      map[i] = { row, rowProps };
    });

    setMap(map);
  }, [columns, products]);

  return rowPropsMap;
}

export default useRowProps;
